var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5003 8.0013C14.5003 4.68759 11.814 2.0013 8.50033 2.0013C5.18662 2.0013 2.50033 4.68759 2.50033 8.0013C2.50033 11.315 5.18662 14.0013 8.50033 14.0013C11.814 14.0013 14.5003 11.315 14.5003 8.0013ZM15.8337 8.0013C15.8337 12.0514 12.5504 15.3346 8.50033 15.3346C4.45024 15.3346 1.16699 12.0514 1.16699 8.0013C1.16699 3.95121 4.45024 0.667969 8.50033 0.667969C12.5504 0.667969 15.8337 3.95121 15.8337 8.0013Z",
    fill: "#FF712D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 8.0013V5.33464C7.83301 4.96645 8.13148 4.66797 8.49967 4.66797C8.86786 4.66797 9.16634 4.96645 9.16634 5.33464V8.0013C9.16634 8.36949 8.86786 8.66797 8.49967 8.66797C8.13148 8.66797 7.83301 8.36949 7.83301 8.0013Z",
    fill: "#FF712D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50618 10L8.57454 10.0033C8.9107 10.0374 9.17285 10.3215 9.17285 10.6667C9.17285 11.0118 8.9107 11.2959 8.57454 11.3301L8.50618 11.3333H8.49967C8.13148 11.3333 7.83301 11.0349 7.83301 10.6667C7.83301 10.2985 8.13148 10 8.49967 10H8.50618Z",
    fill: "#FF712D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert_circle.50a2a136848b6b200e83e33f3d00b982.svg";
export { ForwardRef as ReactComponent };